import { Component, OnDestroy, OnInit, ViewChild, ElementRef } from '@angular/core';
import { RetailHq, RetailHqConfiguration, createRetail, updateRetail } from '../../../modules/users/interface/retail.i';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { RetailService } from '../../../core/routing/services/retail_api/retail.service';
import { first } from 'rxjs/internal/operators/first';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { GlobalConstants } from '../../../../app/common/constants/global.constant';

import { Utils } from '../../../common/utils/utils';
import { throwError } from 'rxjs';
import { StoresConstant } from '../../../core/routing/services/stores_api/constants/stores.constant'
import { RetailStoreConstants } from '../../../core/routing/services/retail_api/constants/retailHq.constants'
import { DomSanitizer } from '@angular/platform-browser';
import { GoogleAnalyticsService } from '../../google-analytics/google-analytics.service';
import { ActiveUserConstants } from 'src/app/core/routing/services/activeusers_api/constatnts/activeusers.constant';
import { CommonService } from '../../../common/services/common.service';
import { Enumvalues } from 'src/app/core/routing/services/pendingUsers/constants/pendingUsers.constant';

@Component({
  selector: 'iposcen-retail-hq',
  templateUrl: './retail-hq.component.html',
  styleUrls: ['./retail-hq.component.scss']
})

export class RetailHqComponent implements OnInit, OnDestroy {
  @ViewChild('colorpicker') colPicModal: ElementRef;
  @ViewChild('searchValue') animateThis: ElementRef;
  isLoading = false;
  isRetailHQTableEmpty: boolean = false;
  globConst = GlobalConstants;
  userRole = sessionStorage.getItem(GlobalConstants.USER_ROLE);
  retailUserId = sessionStorage.getItem(GlobalConstants.RETAILER_ID);
  retailTheme;
  brandCheck = false;
  deviceReviewCheck = false;
  googleAnalyticsCheck = false;
  priceValidityCheck = false;
  brandEdit = false;
  editCheck = false;
  adminUser: boolean;
  retailHqForm: FormGroup;
  unConnectedForm: FormGroup;
  createResponse: createRetail[] = [];
  updateResponse: updateRetail[] = [];
  firstname = sessionStorage.getItem('firstname');
  lastName = sessionStorage.getItem('lastname');
  openModal = false;
  retailData: any = {};
  maxSize = 5;
  configurations: RetailHqConfiguration[];
  displayRetailHqList = [];
  allRetailHqData: RetailHq[] = [];
  allRetailHqcsvData = [];
  detailsResp = {};
  page: number;
  tableSize: number;
  showFrom: number;
  showTo: number;
  retailName: string;
  duplicateRetail = false;
  searchData: string;
  searchNamePlaceHolderText: string;
  retailerPlaceHolderText: string;
  retailerIdPlaceHolderText: string;
  retailerIdModalPlaceHolderText: string;
  analyticsUrlPlaceHolderText: string;
  customisePasswordPlaceHolderText:  string;
  isUrlValid: boolean;
  emailValidationMsg = GlobalConstants.EMAIL_VALIDATION_MSG;
  editTooltip = GlobalConstants.EDIT;
  paginationCount: number;
  totalPages: number;
  filterString: string;
  selectFilterQueue = {};
  searchQueue = {};
  sortQueue = {};
  loadFlag: string;
  searchTag = RetailStoreConstants.SEARCH_BY;
  loginUserRole = sessionStorage.getItem('userRole');
  isAscendingSort = false;
  retailerName = RetailStoreConstants.NAME_SORT;
  retailerId = RetailStoreConstants.RETAILERID_SORT;
  createdTime = RetailStoreConstants.CREATED_SORT;
  updatedTime = RetailStoreConstants.UPDATED_SORT;
  createdSort: string;
  sortType: string;
  compRxtCheck = false;
  zipFileDoc: any;
  zipFileName: string = '';
  fileType: string;
  zipFileTypeError: boolean;
  isZipFileValid: boolean;
  fileUrl: any = '';
  zipTrue: boolean;
  editComp: boolean;
  buttonShow: boolean[] = [];
  searchClose: boolean;
  pollFrequencyLabel = GlobalConstants.POLL_FREQUENCY;
  enabled = GlobalConstants.ENABLED;
  disabled = GlobalConstants.DISABLED;
  editBtnEnabled: boolean;
  savedPopup = false;
  showRetailGif = false;
  autoShutdownErrormsg = false;
  eciErrorMsg = false;
  getFilter: string;
  enable3DMarkFeature: boolean = false;
  isChatbotEnabled: boolean = false;
  unconnectedData: any;
  enableSaveCancelBtns = true;
  customMainTileFlag = false;  // For GA 
  private modalRef: NgbModalRef;
  isBuyNowEnabled: boolean;
  buyNowReferenceId: string;
  apiIdText = GlobalConstants.API_ID_TEXT;
  buyNowText = GlobalConstants.BUY_NOW_TEXT;
  buyNowPopUpText = GlobalConstants.BUY_NOW_POP_UP_TEXT
  buyNowValueCheck: boolean = false;
  processorCoresText =  GlobalConstants.PROCESSOR_CORES_TEXT;
  mandatoryStoreSelection =  GlobalConstants.STORE_SELECTION;
  mandatorySkuSelection =  GlobalConstants.SKU_SELECTION;
  storeSelectionText =  GlobalConstants.STORE_SELECTION_TEXT;
  skuSelectionText =  GlobalConstants.SKU_SELECTION_TEXT;
  iposChinaText =  GlobalConstants.IPOS_LITE_PRC_FLAG;
  customisePasswordText = GlobalConstants.IPOS_LITE_CUSTOMISE_PASSWORD;
  silentInstallationText = GlobalConstants.IPOS_LITE_SILENT_INSTALLATION;
  suppressUninstallIconText = GlobalConstants.IPOS_LITE_SUPPRESS_UNINSTALL_ICON;
  preventAutoLaunchText = GlobalConstants.IPOS_LITE_PREVENT_AUTO_LAUNCH;
  suppressVAText = GlobalConstants.IPOS_LITE_SUPPRESSVA;
  suppressGAText = GlobalConstants.IPOS_LITE_SUPPRESSGA;
  deviceRegistrationText = GlobalConstants.IPOS_LITE_DEVICE_REGISTRATION;
  disableIdleExperienceText = GlobalConstants.IPOS_LITE_SUPPRESS_IDLE_EXPERIENCE;
  twoFAText =  GlobalConstants.TWO_FACTOR_AUTHENTICATION;
  private ngUnsubscribe = new Subject<boolean>();
  constructor(private googleAnalyticsService: GoogleAnalyticsService,
    private retailHqService: RetailService,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private sanitizer: DomSanitizer,
    private cmnService: CommonService) { }

  ngOnInit(): void {
    this.page = 1;
    this.tableSize = 10;
    this.searchData = '';
    this.showFrom = ((this.page - 1) * this.tableSize) + 1;
    this.showTo = Math.min(this.page * this.tableSize);
    this.loadFlag = StoresConstant.LOAD_FLAG;
    this.searchNamePlaceHolderText = $localize`:@@retail-hq.data-header.search-name:Search by Name...`;
    this.retailerPlaceHolderText = $localize`:@@retail-hq.modal-body.new-retail-name-placeholder:Retail HQ Name`;
    this.retailerIdPlaceHolderText = $localize`:@@retail-hq.table-body.retail-id-placeholder:Retailer ID`;
    this.retailerIdModalPlaceHolderText = $localize`:@@retail-hq.table-body.retail-id-placeholder:Retailer ID`;
    this.analyticsUrlPlaceHolderText = $localize`:@@retail-h.analytics-url:Analytics URL`;
    this.customisePasswordPlaceHolderText = '2024demo';
    this.isUrlValid = true;
    this.isZipFileValid = true;
    this.userRole = sessionStorage.getItem('userRole');
    this.createdSort = 'createdtime';
    this.sortType = 'desc';
    if (this.userRole === GlobalConstants.INTEL_ADMIN) {
      this.sortQueue[RetailStoreConstants.SORT_BY] = this.createdTime;
      this.sortQueue[RetailStoreConstants.SORT_TYPES] = this.sortType;
    }
    this.getFilterSearchData();
    this.createRetailHqForm();
    this.prepareRetailThemeForm();
    this.userRole = sessionStorage.getItem('userRole');
    if (this.userRole === 'intelAdmin') {
      this.adminUser = true;
      this.getFilter = this.globConst.CONN_RETAILHQ;
    }
    this.configurations = [];
    this.cmnService.getRetailGifValue
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
        if (data) {
          this.showRetailGif = true;
        }
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  prepareRetailThemeForm() {
    this.retailTheme = {
      bgcolor: '#0068B5',
      heading: '',
      hcolor: '#ffffff'
    };
  }

  dismiss() {
    this.modalRef.close();
  }

  isSelected(bcolor, bgcolor) {
    if (this.retailTheme.bcolor === bcolor && this.retailTheme.bgcolor === bgcolor) {
      return true;
    }

    return false;
  }

  chooseTheme(fontColor: string, bgColor: string) {
    [
      this.retailTheme.bgcolor,
      this.retailTheme.hcolor
    ] =
      [
        bgColor,
        fontColor
      ];
    this.dismiss();
  }

  brandChecks() {
    this.brandCheck = !this.brandCheck;
  }

  deviceReviewChecks() {
    this.deviceReviewCheck = !this.deviceReviewCheck;
  }

  buyNowChecks(action, formdata?) {
   if (action === GlobalConstants.CREATE_TEXT) {
    this.buyNowValueCheck = !this.buyNowValueCheck;

    if (!this.buyNowValueCheck) {
      this.retailHqForm.controls.buyNowReferenceId.setValue('');
    }
   } else if (action === GlobalConstants.EDIT_TEXT) {
     if (!formdata?.configurations?.isBuyNowEnabled) {
      formdata.configurations.buyNowReferenceId = '';
     }
   }
  }
  enableUL3DMarkChecks() {
    //Logic will be taken care in IIT2-1227
  }

  oncheckurl(event) {
    //  this.isUrlValid =  Utils.validateUrl(this.retailHqForm?.controls?.analyticsUrl?.value) || Utils.validateUrl(urlValue);
    const urlValue = event.target.value;
    this.isUrlValid = Utils.validateUrl(urlValue);
  }

  oncheckPrice(event) {
    const priceValue = event.target.value;
  }

  googleAnalyticsChecks() {
    this.googleAnalyticsCheck = !this.googleAnalyticsCheck;
  }

  priceValidityFrequncyChecks() {
    this.priceValidityCheck = !this.priceValidityCheck;
  }


  brandEditCheck(retailData) {
    this.brandEdit = !this.brandEdit;
    retailData.configurations.bgcolor = this.retailTheme.bgcolor;
  }

  createRetailHqForm() {
    this.retailHqForm = this.formBuilder.group({
      retailerName: new FormControl(''),
      expirationDays: new FormControl('30'),
      blockWindows: new FormControl(true),
      srtEnabled: new FormControl(false),
      customSrtEnabled: new FormControl(false),
      removeEnabled: new FormControl(false),
      compRxtEnabled: new FormControl(false),
      bandColor: new FormControl(false),
      bgcolor: new FormControl(''),
      displayDeviceReview: new FormControl(false),
      enable3DMarkFeature: new FormControl(true),
      googleAnalyticsEnabled: new FormControl(false),
      compareDeviceEnabled: new FormControl(false),
      bcNonIntelDeviceEnabled: new FormControl(false),
      isRepairabilityIndexEnabled: new FormControl(false),
      isEciRetailer: new FormControl(false),
      isAutoShutdown: new FormControl(false),
      isPriceSupress: new FormControl(false),
      enableElkjopULBenchmark: new FormControl(false),
      enableUpdateIPOSOverTheAir: new FormControl(false),
      autoUpdateAIContent: new FormControl(true),
      enablePriceMultiDevices: new FormControl(false),
      isChatbotEnabled: new FormControl(true),
      isGamingCubeEnabled: new FormControl(false),
      isGamingBattleEnabled: new FormControl(false),
      priceValidityFrequncy: new FormControl(false),
      processorFactTagSuppress: new FormControl(false),
      displayDeviceRetailerId: new FormControl(''),
      analyticsUrl: new FormControl(''),
      enterFrequency: new FormControl(GlobalConstants.POLL_FREQ_DEFULT_VALUE, [Validators.pattern(/^(?!-\.)([0-9]+)$/)]),
      zipFile: new FormControl(''),
      pollFrequency: new FormControl(GlobalConstants.POLL_FREQ_DEFULT_VALUE, [Validators.min(1), Validators.pattern(/^(?!-\.)([0-9]+)$/)]),
      buyNowReferenceId: new FormControl(''),
      isBuyNowEnabled: new FormControl(false),
      enableUnisonDemo : new FormControl(false),
      enableProcessorCores: new FormControl(false),
      storeSelection: new FormControl(false),
      skuSelection: new FormControl(false),
      isIposChinaEnabled: new FormControl(false),
      customisePassword: new FormControl(''),
      silentInstallUninstall: new FormControl(false),
      suppressUninstallIcon: new FormControl(false),
      preventAutoLaunch: new FormControl(false),
      stopAutoLaunch: new FormControl(false),
      enableVA: new FormControl(false),
      suppressGA: new FormControl(false),
      disableDeviceRegistration: new FormControl(false),
      disableIdleExperience: new FormControl(false),
      mfaEnabled: new FormControl(false),
      offlineVirtualAssistant: new FormControl(false),
      nonIntelGaming: new FormControl(false),
    });
    this.unConnectedForm = this.formBuilder.group({
      enable3DMarkFeature: new FormControl(false),
      isChatbotEnabled: new FormControl(false)
    });
    this.zipTrue = false;
    this.zipFileTypeError = false;
    this.zipFileName = '';
  }

  createRetailHq() {
    const retailHq: createRetail = {
      retailerName: this.retailHqForm.controls.retailerName.value,
      srtEnabled: this.retailHqForm.controls.srtEnabled.value,
      createdByName: this.firstname + ' ' + this.lastName,
      configurations: JSON.stringify({
        customSrtEnabled: this.retailHqForm.controls.customSrtEnabled.value,
        deviceExpirationDays: this.retailHqForm.controls.expirationDays.value,
        blockWindowsUpdate: this.retailHqForm.controls.blockWindows.value,
        removeEnabled: this.retailHqForm.controls.removeEnabled.value,
        compRxtEnabled: this.retailHqForm.controls.compRxtEnabled.value,
        displayDeviceReview: this.retailHqForm.controls.displayDeviceReview.value,
        enable3DMarkFeature: this.retailHqForm.controls.enable3DMarkFeature.value,
        googleAnalyticsEnabled: this.retailHqForm.controls.googleAnalyticsEnabled.value,
        compareDeviceEnabled: this.retailHqForm.controls.compareDeviceEnabled.value,
        bcNonIntelDeviceEnabled: this.retailHqForm.controls.bcNonIntelDeviceEnabled.value,
        processorFactTagSuppress: this.retailHqForm.controls.processorFactTagSuppress.value,
        isRepairabilityIndexEnabled: this.retailHqForm.controls.isRepairabilityIndexEnabled.value,
        isEciRetailer: this.retailHqForm.controls.isEciRetailer.value,
        isAutoShutdown: this.retailHqForm.controls.isAutoShutdown.value,
        isPriceSupress: this.retailHqForm.controls.isPriceSupress.value,
        enableElkjopULBenchmark: this.retailHqForm.controls.enableElkjopULBenchmark.value,
        enableUpdateIPOSOverTheAir: this.retailHqForm.controls.enableUpdateIPOSOverTheAir.value,
        autoUpdateAIContent: this.retailHqForm.controls.autoUpdateAIContent.value,
        enablePriceMultiDevices: this.retailHqForm.controls.enablePriceMultiDevices.value,
        isChatbotEnabled: this.retailHqForm.controls.isChatbotEnabled.value,
        isGamingCubeEnabled: this.retailHqForm.controls.isGamingCubeEnabled.value,
        isGamingBattleEnabled: this.retailHqForm.controls.isGamingBattleEnabled.value,
        storeSelection: this.retailHqForm.controls.storeSelection.value,
        skuSelection: this.retailHqForm.controls.skuSelection.value,
        priceValidityFrequncy: this.retailHqForm.controls.priceValidityFrequncy.value,
        bandColor: this.retailHqForm.controls.bandColor.value,
        bgcolor: this.brandCheck ? this.retailTheme.bgcolor : '',
        displayDeviceRetailerId: this.deviceReviewCheck ? this.retailHqForm.controls.displayDeviceRetailerId.value : '',
        analyticsUrl: this.googleAnalyticsCheck ? this.retailHqForm.controls.analyticsUrl.value : '',
        enterFrequency: this.priceValidityCheck ? this.retailHqForm.controls.enterFrequency.value : '',
        zipFile: this.compRxtCheck ? this.zipFileName : '',
        pollFrequency: this.retailHqForm.controls.pollFrequency.value,
        intelSrtEnabled: this.retailHqForm?.controls?.srtEnabled?.value,
        isBuyNowEnabled: this.retailHqForm?.controls?.isBuyNowEnabled?.value,
        buyNowReferenceId: this.retailHqForm?.controls?.buyNowReferenceId?.value,
        enableUnisonDemo: this.retailHqForm?.controls?.enableUnisonDemo?.value,
        enableProcessorCores: this.retailHqForm.controls?.enableProcessorCores.value,
        isIposChinaEnabled: this.retailHqForm.controls?.isIposChinaEnabled?.value,
        customisePassword: this.retailHqForm.controls?.customisePassword?.value,
        silentInstallUninstall: this.retailHqForm.controls?.silentInstallUninstall?.value,
        suppressUninstallIcon: this.retailHqForm.controls?.suppressUninstallIcon?.value,
        preventAutoLaunch: this.retailHqForm.controls?.preventAutoLaunch?.value,
        stopAutoLaunch: this.retailHqForm.controls?.silentInstallUninstall?.value || this.retailHqForm.controls?.preventAutoLaunch?.value,
        enableVA: this.retailHqForm.controls?.enableVA?.value,
        suppressGA: this.retailHqForm.controls?.suppressGA?.value,
        disableDeviceRegistration: this.retailHqForm.controls?.disableDeviceRegistration?.value,
        disableIdleExperience: this.retailHqForm.controls?.disableIdleExperience?.value,
        mfaEnabled: this.retailHqForm.controls?.mfaEnabled?.value,
        offlineVirtualAssistant: this.retailHqForm.controls?.offlineVirtualAssistant?.value,
        nonIntelGaming: this.retailHqForm.controls?.nonIntelGaming?.value,
      }),
    };
    if (JSON.parse(retailHq?.configurations)?.customSrtEnabled) {
      this.googleAnalyticsService.customMainTileFlagEnabledByRetailer();
    }
    
    let removeRetailerNameSpace = this.retailHqForm.controls.retailerName.value.toLowerCase().trim();
    let exists = this.allRetailHqData.find(resp => resp.retailerName.toLowerCase() == removeRetailerNameSpace);
    if (!exists) {
      this.duplicateRetail = false;
      this.retailHqService.createRetailHq(JSON.stringify(retailHq)).pipe(takeUntil(this.ngUnsubscribe))
        .pipe(first()).subscribe(createRetailResponse => {
          this.createResponse = (createRetailResponse.responseContext as createRetail[]);
          if (createRetailResponse.responseContext.success) {
            if (JSON.parse(retailHq?.configurations)?.enableUpdateIPOSOverTheAir) {
              this.googleAnalyticsService.enableUpdateIPOSOverTheAir('create', 'enable');
            } else {
              this.googleAnalyticsService.enableUpdateIPOSOverTheAir('create', 'disable');
            }
            if (JSON.parse(retailHq?.configurations)?.mfaEnabled) {
              this.googleAnalyticsService.checkTwoFA('create', 1);
            } 
            this.googleAnalyticsService.battleStationDevice( retailHq.retailerName, JSON.parse(retailHq?.configurations)?.isGamingBattleEnabled, 'create' );
            const retailerId = createRetailResponse.retailer.retailerId;
            if (this.compRxtCheck) {
              this.retailHqService.putS3CompRxtZipFile(this.zipFileDoc[0], this.zipFileName.split('.')[1], retailerId, RetailStoreConstants.COMPRXT)
                .pipe(takeUntil(this.ngUnsubscribe))
                .pipe(first())
                .subscribe((data) => {
                  setTimeout(_ => { this.getAllRetailerInfo(this.filterString); }, 2000);
                },
                  error => { // do something
                  });
            } else {
              setTimeout(_ => { this.getAllRetailerInfo(this.filterString); }, 2000);
            }
            this.openModal = false;
            this.cmnService.setCreateRetailPage(false);
            this.resetForm();
            this.animateThis.nativeElement.value = '';
            this.searchData = '';
            this.googleAnalyticsService.addNewRetailerHQ();
          }
        })

      window['dataLayer'].push({
        'new_retailer_hq_added': true
      })
    }
    else {
      this.duplicateRetail = true;
    }
  }

  updateRetail(retailData) {
    retailData.configurations.displayDeviceRetailerId = retailData.configurations.displayDeviceReview ? retailData.configurations.displayDeviceRetailerId : '';
    retailData.configurations.analyticsUrl = retailData.configurations.googleAnalyticsEnabled ? retailData.configurations.analyticsUrl : '';
    retailData.configurations.enterFrequency = retailData.configurations.enterFrequency ? retailData.configurations.enterFrequency : '';
    retailData.configurations.zipFile = retailData.configurations.compRxtEnabled ?
      (this.zipFileName !== '' ? this.zipFileName : retailData.configurations.zipFile) : '';
    retailData.configurations.intelSrtEnabled = retailData?.srtEnabled;
    retailData.configurations.buyNowReferenceId = retailData?.configurations?.isBuyNowEnabled ? retailData?.configurations?.buyNowReferenceId : '';
    if (!retailData.configurations.preventAutoLaunch && !retailData.configurations.silentInstallUninstall) {
      retailData.configurations.stopAutoLaunch = false;
    } else {
      retailData.configurations.stopAutoLaunch = true;
    }
     if (retailData?.configurations?.customSrtEnabled && !this.customMainTileFlag) {
      this.googleAnalyticsService.customMainTileFlagEnabledByRetailer();
    }
    const updateHq: updateRetail = {
      configurations: JSON.stringify(retailData.configurations),
      retailerName: this.retailName,
      srtEnabled: retailData.srtEnabled
    }
    let id = retailData.retailerId
    if (!retailData.retailerName) {
      delete retailData.retailerName;
    }
    this.retailHqService.putRetailHqById(JSON.stringify(updateHq), id).pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first()).subscribe(updateRetailResponse => {
        this.updateResponse = (updateRetailResponse.responseContext as updateRetail[]);
        if (updateRetailResponse.responseContext.success) {
          this.googleAnalyticsService.battleStationDevice( updateHq.retailerName, retailData?.configurations?.isGamingBattleEnabled, 'update');
          if (retailData.configurations.compRxtEnabled && this.zipFileDoc?.length) {
            this.retailHqService.putS3CompRxtZipFile(this.zipFileDoc[0], this.zipFileName.split('.')[1], id, RetailStoreConstants.COMPRXT)
              .pipe(takeUntil(this.ngUnsubscribe))
              .pipe(first())
              .subscribe((data) => {
                this.getAllRetailerInfo(this.filterString);
              },
                error => { // do something
                });
          } else {
            this.clearSearch('');
          }
          this.animateThis.nativeElement.value = '';
          this.searchData = '';
          this.zipFileName = '';
          const value = retailData?.configurations?.enableUpdateIPOSOverTheAir ? 'enable' : 'disable';
          this.googleAnalyticsService.enableUpdateIPOSOverTheAir('update', value);
          const mfaValue = retailData?.configurations?.mfaEnabled ? 1 : 0;
          if(mfaValue == 1){
            this.googleAnalyticsService.checkTwoFA('update', mfaValue);
          }
        }
      },
        error => {
          this.duplicateRetail = true;
        });
    this.buttonShow[id] = false;
  }

  openColPicModal() {
    this.modalRef = this.modalService.open(this.colPicModal);
    this.modalRef.result.then();
  }

  openCreateModal() {
    this.openModal = true;
    this.autoShutdownErrormsg = false;
    this.eciErrorMsg = false;
    this.cmnService.setCreateRetailPage(true);
    this.isUrlValid = true;
    this.createRetailHqForm();
  }

  resetForm() {
    this.retailHqForm.reset();
    this.brandCheck = false;
    this.deviceReviewCheck = false;
    this.googleAnalyticsCheck = false;
    this.priceValidityCheck = false;
    this.compRxtCheck = false;
    this.zipFileName = '';
    this.zipTrue = false;
    this.zipFileTypeError = false;
    this.retailTheme.bgcolor = '#0068B5';
    this.retailHqForm = this.formBuilder.group({
      expirationDays: new FormControl('30'),
      blockWindows: new FormControl(true),
    });
  }

  CloseRetailModal() {
    this.openModal = false;
    this.autoShutdownErrormsg = false;
    this.eciErrorMsg = false;
    this.cmnService.setCreateRetailPage(false);
    this.duplicateRetail = false;
    this.resetForm();
    // for Bug IIT3-1228
    if(this.getFilter == this.globConst.CONN_RETAILHQ){
      this.onFilter('1');
    }
    if(this.getFilter == this.globConst.UNCONNECTED_USERS){
      this.onFilter('2');
    }
  }

  // getting all retail hq data
  getAllRetailerInfo(filterString?: string) {
    this.retailHqService.getAllRetailerInfoSortBy(this.retailUserId,
      this.page, filterString)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(getAllRetailHqResponse => {
        if (this.userRole === GlobalConstants.RETAIL_HQ_USER || this.userRole === ActiveUserConstants.REGIONAL_USER_ROLE) {
          this.allRetailHqData = [getAllRetailHqResponse.retailer];
          this.paginationCount = 1;
        } else {
          this.allRetailHqData = (getAllRetailHqResponse.retailer as RetailHq[]);
          this.paginationCount = (getAllRetailHqResponse.paginationContext.totalItems);
          this.totalPages = (getAllRetailHqResponse.paginationContext.totalPages);
        }
        this.showFrom = ((this.page - 1) * this.tableSize) + 1;
        this.showTo = Math.min(this.page * this.tableSize, this.paginationCount);

        if (this.allRetailHqData.length === 0) {
          this.showFrom = 0;
          this.showTo = 0;
        }
        this.displayRetailHqList = [];
        this.allRetailHqData.forEach(ele => {
          this.displayRetailHqList.push(ele);
        });
        this.isRetailHQTableEmpty = (this.displayRetailHqList?.length === 0) || false;
        this.displayRetailHqList.forEach(element => {
          if (element.retailerName) {
            element.configurations = (JSON.parse(element.configurations) as RetailHqConfiguration[]);
            // adding this custom property to know which Banner content is expanded
            element.isExpanded = false;
            element.isEdit = false;
          }
        });
        this.cmnService.setRetailGifValue(false);
        this.eciErrorMsg = false;
        this.autoShutdownErrormsg = false;
      },
        error => {
          this.handleError(error, this.constructor.name);
          this.isRetailHQTableEmpty = true;
        });
  }

  getAllRetailerInfoSearchByName() {
    this.animateThis.nativeElement.blur();
    this.retailHqService.getAllRetailerInfoSearchByName(this.animateThis.nativeElement.value, this.page)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(getAllRetailHqResponse => {
        this.allRetailHqData = (getAllRetailHqResponse.retailer as RetailHq[]);
        this.showFrom = 1;
        this.showTo = 10;
        this.page = 1;
        this.displayRetailHqList = [];
        this.allRetailHqData.forEach(ele => {
          this.displayRetailHqList.push(ele);
        });
        this.displayRetailHqList.forEach(element => {
          element.configurations = (JSON.parse(element.configurations) as RetailHqConfiguration[]);
          element.isExpanded = false;
        });
      });
  }

  checkAccordianOpen(id): boolean {
    let isValid = false;
    this.displayRetailHqList.forEach(element => {
      if (element.retailerId === id) {
        if (element.isExpanded) {
          isValid = true;
        }
      }
    });

    return isValid;
  }

  getDetailsOfRetailHq(id: string, action?: string) {
    this.isUrlValid = true;
    this.buttonShow[id] = !this.buttonShow[id];

    this.displayRetailHqList.forEach(element => {
      if (element.retailerId === id) {
        element.isExpanded = !element.isExpanded;
        if (!element.isExpanded) {
          element.isEdit = false;
        }
      }
    });
    let index = this.displayRetailHqList?.findIndex(ele => ele.retailerId === id);
    if (this.displayRetailHqList.length > 0) {
      this.editBtnEnabled = (!this.displayRetailHqList[index].isExpanded && !this.displayRetailHqList[index].isEdit && action === 'caret') ? true : false;
    }
    if (this.editBtnEnabled && this.userRole === 'intelAdmin') {
      this.refreshRetailHQRecord(id);
    } else {
      // Add TODO when we expand other item first data is refreshing
      this.configurations = [];
      this.retailHqService.getAllRetailerInfoById(id)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(getAllRetailHqResponse => {
          this.detailsResp = getAllRetailHqResponse.retailer;
          this.retailName = getAllRetailHqResponse.retailer.retailerName.trim();
          this.retailData.configurations = (JSON.parse(getAllRetailHqResponse.retailer.configurations) as RetailHqConfiguration[]);
        });
    }
  }

  onTableDataChange(event) {
    this.page = event;
    this.getAllRetailerInfo(this.filterString);
  }

  editRetailDetails(id: string) {
    this.duplicateRetail = false;
    this.displayRetailHqList.forEach(element => {
      if (element.retailerId === id) {
        element.isEdit = true;
        if (element.isEdit) {
          this.editComp = element.configurations.compRxtEnabled;
          if (!element.configurations?.pollFrequency) { // For old records which doesn't has PollFrequency 
            element.configurations.pollFrequency = 10;
          }
          if (!element.configurations?.customSrtEnabled) {
            element.configurations.customSrtEnabled = false;
          }
          this.customMainTileFlag = element.configurations?.customSrtEnabled;
          //Adding  new flags if doesn't exist as part of config object.
          if (!element.configurations.processorFactTagSuppress) {
            element.configurations.processorFactTagSuppress = false;
          }
          if (!element.configurations.isRepairabilityIndexEnabled) {
            element.configurations.isRepairabilityIndexEnabled = false;
          }
          if (!element.configurations.isChatbotEnabled) {
            element.configurations.isChatbotEnabled = false;
          }
          if (!element.configurations.priceValidityFrequncy) {
            element.configurations.priceValidityFrequncy = false;
          }
          if (!element.configurations.isEciRetailer) {
            element.configurations.isEciRetailer = false;
          }
          if (!element.configurations.isAutoShutdown) {
            element.configurations.isAutoShutdown = false;
          }
          if (!element.configurations.isPriceSupress) {
            element.configurations.isPriceSupress = false;
          }
          if (!element?.configurations?.enableElkjopULBenchmark) {
            element.configurations.enableElkjopULBenchmark = false;
          }
          if (!element?.configurations?.enableUpdateIPOSOverTheAir) {
            element.configurations.enableUpdateIPOSOverTheAir = false;
          }
          if (!element?.configurations?.autoUpdateAIContent) {
            element.configurations.autoUpdateAIContent = false;
          }
          if (!element?.configurations?.enablePriceMultiDevices) {
            element.configurations.enablePriceMultiDevices = false;
          }
          if (!element.configurations.isGamingCubeEnabled) {
            element.configurations.isGamingCubeEnabled = false;
          }
          if (!element.configurations.isGamingBattleEnabled) {
            element.configurations.isGamingBattleEnabled = false;
          }
          if (!element?.srtEnabled) {
            element.srtEnabled = false;
          }
          if (!element?.configurations?.intelSrtEnabled) {
            element.configurations.intelSrtEnabled = element?.srtEnabled;
          }
          if (!element.configurations.enableUnisonDemo) {
            element.configurations.enableUnisonDemo = false;
          }
          if (!element?.configurations?.enableProcessorCores) {
            element.configurations.enableProcessorCores = false;
          }
          if (!element?.configurations?.storeSelection) {
            element.configurations.storeSelection = false;
          }
          if (!element?.configurations?.skuSelection) {
            element.configurations.skuSelection = false;
          }
          if (!element?.configurations?.isIposChinaEnabled) {
            element.configurations.isIposChinaEnabled = false;
          }
          if (!element?.configurations?.customisePassword) {
            element.configurations.customisePassword = '';
          }
          if (!element?.configurations?.silentInstallUninstall) {
            element.configurations.silentInstallUninstall = false;
          }
          if (!element?.configurations?.suppressUninstallIcon) {
            element.configurations.suppressUninstallIcon = false;
          }
          if (!element?.configurations?.preventAutoLaunch) {
            element.configurations.preventAutoLaunch = false;
          }
          if (element?.configurations?.silentInstallUninstall || element?.configurations?.preventAutoLaunch) {
            element.configurations.stopAutoLaunch = true;
          }
          if (!element?.configurations?.silentInstallUninstall && !element?.configurations?.preventAutoLaunch) {
            element.configurations.stopAutoLaunch = false;
          }
          if (!element?.configurations?.enableVA) {
            element.configurations.enableVA = false;
          }
          if (!element?.configurations?.suppressGA) {
            element.configurations.suppressGA = false;
          }
          if (!element?.configurations?.disableDeviceRegistration) {
            element.configurations.disableDeviceRegistration = false;
          }
          if (!element?.configurations?.disableIdleExperience) {
            element.configurations.disableIdleExperience = false;
          }
          if (!element?.configurations?.mfaEnabled) {
            element.configurations.mfaEnabled = false;
          }
          if (!element?.configurations?.offlineVirtualAssistant) {
            element.configurations.offlineVirtualAssistant = false;
          }          
          if (!element?.configurations?.nonIntelGaming) {
            element.configurations.nonIntelGaming = false;
          }          
        }
      }
    });
    this.zipFileName = '';
    this.isUrlValid = true;
    this.zipTrue = true;
    this.isZipFileValid = true;

    if (!this.checkAccordianOpen(id)) {
      this.getDetailsOfRetailHq(id);
    }

  }
  cancelEdit(id: string) {
    this.zipFileTypeError = false;
    this.zipFileName = '';
    this.buttonShow[id] = false;
    this.refreshRetailHQRecord(id);
    this.clearSearch('');
  }

  refreshRetailHQRecord(id: string) {
    let index = this.displayRetailHqList.findIndex(ele => ele.retailerId === id);
    if (index > -1) {
      this.displayRetailHqList[index].isEdit = false;
      this.displayRetailHqList[index].isExpanded = false;
    }
    this.getAllRetailerInfo(this.filterString);
    this.animateThis.nativeElement.value = '';
    this.searchData = '';
  }

  avoidSymbols(event) {
    event.target.value = event.target.value.replace(/_/g, '');
  }

  pollFrequencyCheck(event) {
    return (Number.isInteger(event));
  }

  clearSearch(val: string) {
    if (val?.length === 0 && this.searchClose) {
      this.searchQueue = {};
      this.getFilterSearchData();
      this.searchData = RetailStoreConstants.EMPTY_VALUE;
      this.showFrom = this.page = 1;
      this.showTo = 10;
      this.searchClose = false;
    }
  }

  downloadCsvFile() {
    if (navigator.onLine) {
      const retailhqrequestBody = {
        "csvHeaders": [
          GlobalConstants.USERS_RETAILHQ_ID,
          GlobalConstants.USERS_RETAILHQ_NAME,
          GlobalConstants.USERS_RETAILHQ_CREATED_AT,
          GlobalConstants.USERS_RETAILHQ_UPDATED_AT,
          GlobalConstants.USERS_RETAILHQ_DEV_EXP_DAYS,
          GlobalConstants.USERS_RETAILHQ_BLOCK_WINUPD,
          GlobalConstants.USERS_RETAILHQ_CUSTOM_BRAND_COL,
          GlobalConstants.USERS_RETAILHQ_DAS_REP_INDEX,
          GlobalConstants.STORE_COUNT,
          GlobalConstants.ACTIVE_DEVICE
        ]
      };
      this.retailHqService.postAllRetailerInfoforCsv(retailhqrequestBody)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(getAllRetailHqResponse => {
          this.allRetailHqcsvData = getAllRetailHqResponse;
          let todayTime = new Date();
          let month = (todayTime.getMonth() + 1);
          let day = ('0' + todayTime.getDate()).slice(-2);
          let year = todayTime.getFullYear();
          let filename = GlobalConstants.USERS_RETAILHQS_CSV_FILENAME;
          let retailerfilename = month + '_' + day + '_' + year + '_' + filename; //filename + '_' + day + month + year;
          const blob = new Blob(['\ufeff' + this.allRetailHqcsvData], { type: 'text/csv;charset=utf-8;' });
          const dwldLink = document.createElement("a");
          const url = URL.createObjectURL(blob);
          const isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
          if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
            dwldLink.setAttribute("target", "_blank");
          }
          dwldLink.setAttribute("href", url);
          dwldLink.setAttribute("download", retailerfilename + ".csv");
          dwldLink.style.visibility = "hidden";
          document.body.appendChild(dwldLink);
          dwldLink.click();
          document.body.removeChild(dwldLink);
        });
    } else {
      // TODO
    }
  }
  searchRetailData(searchData) {
    if (this.loadFlag === StoresConstant.LOAD_FLAG && !this.searchTag) {
      this.loadFlag = StoresConstant.UNLOAD_FLAG;
    }
    if (searchData && this.searchTag) {
      this.searchClose = true;
      this.searchQueue[this.searchTag] = searchData;
      this.getFilterSearchData();
      this.editRetailDetails(this.retailerId);
    } else {
      this.getAllRetailerInfo();
      this.page = 1;
    }
  }

  searchtheUserssonEnter(searchData) {
    this.animateThis.nativeElement.blur();
    this.searchRetailData(searchData);
  }

  getFilterSearchData() {
    this.filterString = '';
    this.page = 1;
    if (this.searchQueue || this.sortQueue) {
      for (const [filterKeyName, fliterData] of Object.entries(this.selectFilterQueue)) {
        this.filterString += `&${filterKeyName}=${fliterData}`;
      }
      if (this.searchQueue) {
        for (const [filterKeyName, fliterData] of Object.entries(this.searchQueue)) {
          this.filterString += `&${filterKeyName}=${fliterData}`;
        }
      }
      if (this.sortQueue) {
        for (const [filterKeyName, fliterData] of Object.entries(this.sortQueue)) {
          this.filterString += `&${filterKeyName}=${fliterData}`;
        }
      }
      this.getAllRetailerInfo(this.filterString);
    } else {
      this.getAllRetailerInfo();
    }
  }

  sort(sortKey: string) {
    this.sortQueue = {};
    switch (sortKey) {
      case (RetailStoreConstants.NAME_SORT):
        this.sortingTableWithAscandDesc(RetailStoreConstants.NAME_SORT);
        break;
      case (RetailStoreConstants.RETAILERID_SORT):
        this.sortingTableWithAscandDesc(RetailStoreConstants.RETAILERID_SORT);
        break;
      case (RetailStoreConstants.CREATED_SORT):
        this.sortingTableWithAscandDesc(RetailStoreConstants.CREATED_SORT);
        break;
      case (RetailStoreConstants.UPDATED_SORT):
        this.sortingTableWithAscandDesc(RetailStoreConstants.UPDATED_SORT);
        break;
      default: {
      }
    }
    // }
  }

  sortingTableWithAscandDesc(tempval: string) {
    let sortOrder = RetailStoreConstants.EMPTY_VALUE;
    this.isAscendingSort = !this.isAscendingSort;
    sortOrder = this.isAscendingSort ? RetailStoreConstants.ASCENDING_ORDER :
      RetailStoreConstants.DESCENDING_ORDER;
    this.sortQueue[RetailStoreConstants.SORT_BY] = tempval;
    this.sortQueue[RetailStoreConstants.SORT_TYPES] = sortOrder;
    this.getFilterSearchData();
  }

  sortAlpabetically(arrayValue: any): string[] {
    return arrayValue.sort((a, b) => a.localeCompare(b));
  }

  //Handling error within the component
  handleError(error, componentName) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}\nComponent: ${componentName}`;
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.responseContext.exceptionResponse.errorCode}\nMessage: ${error.responseContext.exceptionResponse.errorMessage} with Status Code: ${error.responseContext.exceptionResponse.statusCode}\nComponent: ${componentName}`;
    }
    return throwError(errorMessage);
  }

  compRxtEnable() {
    this.compRxtCheck = !this.compRxtCheck;
    if (!this.compRxtCheck) {
      this.zipFileTypeError = false;
      this.zipFileName = '';
      this.zipTrue = false;
    }
  }

  editCompRxt1(status) {
    if (status && this.zipFileName !== '' && !this.zipFileTypeError) {
      this.zipTrue = true
    } else {
      this.zipTrue = false
    }
  }

  uploadZipFile(event) {
    this.zipFileTypeError = false;
    this.zipFileDoc = event.target.files;
    if (this.zipFileDoc) {
      const reader = new FileReader();
      reader.readAsDataURL(this.zipFileDoc[0]);
      this.fileType = this.zipFileDoc[0].type;
      const fileType = this.zipFileDoc[0].type.split('/')[1];
      this.zipFileTypeError = (
        this.fileType === GlobalConstants.ZIP_FILE_TYPE ||
        this.fileType === GlobalConstants.ZIP_FILE_MAC
      ) ? false : true;
      this.isZipFileValid = !this.zipFileTypeError;
      if (!this.zipFileTypeError) {
        this.zipTrue = true;
        this.zipFileName = this.zipFileDoc[0].name;
        this.fileUrl = '';
        this.fileUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(this.zipFileDoc[0]));
      } else {
        this.zipTrue = false;
      }
    }
  }

  getAllRetailHqData() {
    this.retailHqService.getAllRetailerInfo(StoresConstant.CREATED_TIME, RetailStoreConstants.DESCENDING_ORDER)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(result => {
        this.allRetailHqData = (result.retailer as RetailHq[]);
        this.displayRetailHqList = [];
        this.allRetailHqData.forEach(ele => {
          this.displayRetailHqList.push(ele);
        });
        this.isRetailHQTableEmpty = (this.displayRetailHqList?.length === 0) || false;
        this.displayRetailHqList.forEach(element => {
          element.configurations = (JSON.parse(element.configurations) as RetailHqConfiguration[]);
          // adding this custom property to know which Banner content is expanded
          element.isExpanded = false;
          element.isEdit = false;
        });
      },
        error => {
          this.handleError(error, this.constructor.name);
          this.isRetailHQTableEmpty = true;
        });
  }

  checkAutoShutdownStatus(data, indexVal?: any, event?) {
    if (data === 'new') {
      if (this.retailHqForm?.controls?.isEciRetailer?.value) {
        this.retailHqForm.patchValue({ isAutoShutdown: false });
        this.autoShutdownErrormsg = true;
      } else {
        this.autoShutdownErrormsg = false;
        this.eciErrorMsg = false;
      }
    }
    else if (data === 'edit') {
      if (this.displayRetailHqList[indexVal]?.configurations?.isEciRetailer) {
        this.displayRetailHqList[indexVal].configurations.isAutoShutdown = false;
        event.target.checked = false;
        this.autoShutdownErrormsg = true;
      } else {
        this.autoShutdownErrormsg = false;
        this.eciErrorMsg = false;
      }
    }
  }

  checkEciStatus(data, index?: any, event?) {
    if (data === 'new') {
      if (this.retailHqForm?.controls?.isAutoShutdown?.value) {
        this.retailHqForm.patchValue({ isEciRetailer: false });
        this.eciErrorMsg = true;
      } else {
        this.eciErrorMsg = false;
        this.autoShutdownErrormsg = false;
      }
    } else if (data === 'edit') {
      if (this.displayRetailHqList[index]?.configurations?.isAutoShutdown) {
        this.displayRetailHqList[index].configurations.isEciRetailer = false;
        event.target.checked = false;
        this.eciErrorMsg = true;
      } else {
        this.eciErrorMsg = false;
        this.autoShutdownErrormsg = false;
      }
    }
  }

  async onFilter(value) {
    if (value === Enumvalues.VALUE_1) {
      this.getFilter = this.globConst.CONN_RETAILHQ;
    } else if (value === Enumvalues.VALUE_2) {
      this.getFilter = this.globConst.UNCONNECTED_USERS;
    }
    if (this.getFilter === this.globConst.UNCONNECTED_USERS) {
      this.enableSaveCancelBtns = true;
      await this.getUnconnectedDetails();
      this.setSavedValues();
    }
  }

  closeSavedModal() {
    this.savedPopup = false;
    this.enableSaveCancelBtns = true;
    this.getUnconnectedDetails();
  }

  changeFeature() {
    this.enableSaveCancelBtns = false;
  }

  getUnconnectedDetails() {
    return new Promise((resolve, reject) => {
      this.retailHqService.getUnconnectedRetailer().pipe(takeUntil(this.ngUnsubscribe))
        .pipe(first()).subscribe(getUnconnectedResponse => {
          if (getUnconnectedResponse) {
            this.unconnectedData = JSON.parse(getUnconnectedResponse?.retailer?.configurations);
            resolve(getUnconnectedResponse);
          }
        });
    });
  }

  setSavedValues() {
    this.unConnectedForm.patchValue({
      isChatbotEnabled: this.unconnectedData?.isChatbotEnabled,
      enable3DMarkFeature: this.unconnectedData?.enable3DMarkFeature
    });
  }
  cancelUnconnectedPage() {
    this.setSavedValues();
    this.enableSaveCancelBtns = true;
  }

  updateUnconnectedRequest() {
    const updateUnconHq: updateRetail = {
      configurations: JSON.stringify({
        isChatbotEnabled: this.unConnectedForm?.controls?.isChatbotEnabled?.value,
        enable3DMarkFeature: this.unConnectedForm?.controls?.enable3DMarkFeature?.value,
      })
    }
    this.retailHqService.putRetailHqById(JSON.stringify(updateUnconHq), GlobalConstants.UNCONNECTED_ID).pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first()).subscribe(updateRetailResponse => {
        if (updateRetailResponse) {
          this.savedPopup = true;
        }
      });
  }
}
